import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import "./Sectors.css";

/* ===== Icônes (stroke = currentColor) ===== */
const baseIconProps = {
  className: "ami-icon",
  viewBox: "0 0 72 48",
  "aria-hidden": "true",
  focusable: "false",
};

const IconPont = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12h64" />
      <path d="M6 10h60" strokeDasharray="6 4" />
      <path d="M14 12v24M58 12v24" />
      <path d="M34 12v10" />
      <circle cx="34" cy="25" r="3" />
      <path d="M34 28v6" />
      <path d="M32 36h4v6h-4z" />
    </g>
  </svg>
);

const IconPotence = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 8v32" />
      <path d="M12 10h40" />
      <path d="M20 8h30" strokeDasharray="6 4" />
      <path d="M52 10v10" />
      <circle cx="52" cy="23" r="3" />
      <path d="M52 26v6" />
      <path d="M50 34h4v6h-4z" />
    </g>
  </svg>
);

const IconPalan = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M30 10h12a6 6 0 0 1 0 12H30a6 6 0 0 1 0-12Z" />
      <path d="M36 22v12" />
      <circle cx="36" cy="36" r="3" />
      <path d="M34 39h4v5h-4z" />
    </g>
  </svg>
);

const IconRadio = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <rect x="26" y="8" width="20" height="32" rx="4" />
      <circle cx="36" cy="14" r="2" />
      <circle cx="36" cy="22" r="2" />
      <circle cx="36" cy="28" r="2" />
      <circle cx="36" cy="34" r="2" />
    </g>
  </svg>
);

const IconElec = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M30 6l-8 18h10l-6 18 24-24h-12l8-12z" />
    </g>
  </svg>
);

const IconThermo = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <rect x="28" y="6" width="16" height="24" rx="8" />
      <path d="M36 30v10" />
      <circle cx="36" cy="40" r="4" />
    </g>
  </svg>
);

/* === Icônes pour la section Atouts === */
const IconExperience = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="18" cy="24" r="10" />
      <path d="M18 24l6-4" />
      <path d="M34 14h20M34 24h20M34 34h20" />
    </g>
  </svg>
);

const IconExpertise = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 36l12-24 12 24z" />
      <path d="M18 24h12" />
      <circle cx="48" cy="20" r="8" />
      <path d="M44 20h8M48 16v8" />
    </g>
  </svg>
);

const IconAtouts = () => (
  <svg {...baseIconProps}>
    <g fill="none" strokeWidth="2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 12l24-6 24 6v10c0 14-10 22-24 26-14-4-24-12-24-26V12z" />
      <path d="M24 24l6 6 14-14" />
    </g>
  </svg>
);

/* ===== Données ===== */
const levageItems = [
  { href: "#ponts", label: "Ponts roulants", Icon: IconPont },
  { href: "#manu", label: "Manutentions légères", Icon: IconPont },
  { href: "#palans", label: "Palans électriques", Icon: IconPalan },
  { href: "#potences", label: "Potences", Icon: IconPotence },
  { href: "#palo", label: "Palonniers", Icon: IconPotence },
  { href: "#radio", label: "Radiocommandes", Icon: IconRadio },
];

const elecItems = [
  { href: "#install", label: "Installations BT/HT", Icon: IconElec },
  { href: "#armoires", label: "Armoires & TGBT", Icon: IconElec },
  { href: "#mise-terre", label: "Mises à la terre", Icon: IconElec },
  { href: "#para", label: "Paratonnerres", Icon: IconElec },
  { href: "#atex", label: "Zones ATEX", Icon: IconElec },
  { href: "#thermo", label: "Thermographie", Icon: IconThermo },
];

/* ===== Données — Expérience/Expertise/Atouts ===== */
const strengths = [
  {
    title: "Expérience",
    Icon: IconExperience,
    points: [
      "20+ ans cumulés en inspection et contrôle",
      "Chantiers industriels, portuaires et BTP",
      "Clients PME ↔ grands comptes",
    ],
  },
  {
    title: "Expertise",
    Icon: IconExpertise,
    points: [
      "Références Code du travail, NM/ISO, Eurocodes, ISM/SOLAS",
      "Méthodes CND (PT, MT, UT, ET, RT) & diagnostics IR",
      "Procédures et checklists opérationnelles",
    ],
  },
  {
    title: "Nos atouts",
    Icon: IconAtouts,
    points: [
      "Réactivité < 24h & planning maîtrisé",
      "Rapports clairs, actions correctives priorisées",
      "Traçabilité 100% & interlocuteur unique",
    ],
  },
];

/* ===== Composant ===== */
export default function Sectors() {
  // Reveal on scroll + stagger dynamique
  useEffect(() => {
    const groups = [
      ...document.querySelectorAll(".svc-list"),
      ...document.querySelectorAll(".strengths-grid"),
      document // fallback pour tout le reste
    ];

    // Stagger par groupe (80ms d’écart)
    groups.forEach((root) => {
      const items =
        root === document
          ? Array.from(document.querySelectorAll(".reveal")).filter(
              (el) => ![...groups].some((g) => g !== document && g.contains(el))
            )
          : Array.from(root.querySelectorAll(":scope > .reveal, :scope > * > .reveal, :scope > * .reveal"));

      items.forEach((el, i) => el.style.setProperty("--reveal-delay", `${(i % 6) * 80}ms`));
    });

    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -10% 0px" }
    );

    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, []);

  return (
    <main>
      {/* ========= VERATRAC SAFETY — QUI SOMMES-NOUS ========= */}
      <section className="ami-section reveal ami-veratrac" id="a-propos" aria-labelledby="levage-title">
        <div className="ami-col">
          <header className="ami-head">
            <span className="ami-badge" aria-hidden="true">VERATRAC SAFETY</span>
            <h2 className="ami-h2" id="levage-title">
              <span className="ami-title">Qui sommes-nous</span>
              <span className="ami-kicker">Notre approche : la conformité anticipée, gage de sérénité</span>
            </h2>
            <p className="ami-lead">
              Nous croyons à la <strong>prévention</strong> : identifier tôt les non-conformités, éviter les incidents,
              réduire les arrêts et protéger vos équipes. Anticiper, c’est <strong>sécuriser la pérennité</strong> de vos opérations.
            </p>
          </header>

          <div className="ami-grid">
            {/* reveal ajouté */}
            <article className="ami-card reveal">
              <h3>Pourquoi choisir VERATRAC SAFETY ?</h3>
              <p>
                Un interlocuteur unique pour orchestrer vos <strong>vérifications périodiques</strong>, vos
                <strong> obligations réglementaires</strong> et vos <strong>contrôles techniques</strong> complémentaires
                (levage, pression, électricité, CND, thermographie, maritime, construction).
              </p>
              <div className="svc-card__media">
                <img src="/images/entreprise.jpg" alt="Inspection d’un tableau électrique" loading="lazy" />
              </div>
              <ul className="ami-bullets">
                <li><span className="dot" />Conformité marocaine & internationales (Code du travail, arrêtés, NM/ISO, Eurocodes, ISM/SOLAS…)</li>
                <li><span className="dot" />Méthodes d’inspection éprouvées et rapports exploitables</li>
                <li><span className="dot" />Planification & traçabilité : zéro oubli, zéro stress</li>
                <li><span className="dot" />Conseils actionnables pour lever les réserves plus vite</li>
              </ul>
            </article>

            {/* reveal ajouté */}
            <aside className="ami-stats reveal">
              <div className="stat">
                <div className="stat-n">100%</div>
                <div className="stat-l">Qualité</div>
              </div>
              <div className="stat">
                <div className="stat-n">7</div>
                <div className="stat-l">domaines couverts</div>
              </div>
              <div className="stat">
                <div className="stat-n">24h</div>
                <div className="stat-l">réactivité terrain</div>
              </div>
              <div className="stat">
                <div className="stat-n">100%</div>
                <div className="stat-l">traçabilité</div>
              </div>
            </aside>
          </div>

          <footer className="ami-cta">
            <a href="#contact" className="btn-primary">Faire une consultation</a>
            <a href="#services" className="btn-secondary">Voir nos services</a>
          </footer>
        </div>
      </section>

      {/* ============= SERVICES ============= */}
      <section className="svc" id="services">
        <div className="svc-intro">
          <h2 className="svc-title">Nos services</h2>
          <p className="svc-lead">
            <strong>VERATRAC SAFETY</strong> vous accompagne sur la conformité réglementaire, les contrôles non destructifs,
            l’ingénierie et le contrôle technique de construction, l’expertise maritime et la formation professionnelle.
          </p>
        </div>

        <div className="svc-list">
          {/* ---- Installations électriques ---- */}
          <article id="installations-electriques" className="svc-card reveal" aria-labelledby="elec-title">
            <div className="svc-card__text">
              <div className="svc-badge">Électricité</div>
              <h3 className="svc-card__title" id="elec-title">Installations électriques</h3>
              <p className="svc-card__desc">
                Le contrôle des installations électriques vise à assurer la protection des personnes et des biens contre les
                risques d’électrocution, de court-circuit et d’incendie. Il garantit la conformité des équipements aux normes
                en vigueur et prévient les interruptions imprévues d’activité.
              </p>
              <Link to="/services/installations-electriques" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/elctrique_.jpeg" alt="Inspection d’un tableau électrique" loading="lazy" />
            </div>
          </article>

          {/* ---- Ascenseurs & monte-charges ---- */}
          <article id="ascenseurs-monte-charges" className="svc-card svc-card--alt reveal" aria-labelledby="asc-title">
            <div className="svc-card__text">
              <div className="svc-badge">Conformité</div>
              <h3 className="svc-card__title" id="asc-title">Ascenseurs & monte-charges</h3>
              <p className="svc-card__desc">
                Essais de réception et visites périodiques pour garantir la sécurité des usagers et attester la conformité
                réglementaire des installations verticales.
              </p>
              <Link to="/services/ascenseurs-monte-charges" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/ascenseur.jpeg" alt="Contrôle d’un ascenseur" loading="lazy" />
            </div>
          </article>

          {/* ---- Contrôle des tubes ---- */}
          <article id="controle-tubes" className="svc-card reveal" aria-labelledby="tubes-title">
            <div className="svc-card__text">
              <div className="svc-badge">CND</div>
              <h3 className="svc-card__title" id="tubes-title">Contrôle des tubes</h3>
              <p className="svc-card__desc">
                Courants de Foucault (RFT) et mesures d’épaisseur pour détecter corrosion, érosion et piqûration sur échangeurs,
                condenseurs et chaudières — sans démontage lourd.
              </p>
              <Link to="/services/controle-tubes" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/tube.jpg" alt="Inspection d’échangeur tubulaire" loading="lazy" />
            </div>
          </article>

          {/* ---- Contrôle des câbles ---- */}
          <article id="controle-cables" className="svc-card svc-card--alt reveal" aria-labelledby="cables-title">
            <div className="svc-card__text">
              <div className="svc-badge">Levage</div>
              <h3 className="svc-card__title" id="cables-title">Contrôle des câbles</h3>
              <p className="svc-card__desc">
                Méthode magnétique à faible champ : détection des ruptures internes/externes et quantification de la perte
                de section pour éviter les ruptures et arrêts imprévus.
              </p>
              <Link to="/services/controle-cables" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/cable.jpg" alt="Inspection d’un câble de levage" loading="lazy" />
            </div>
          </article>

          {/* ---- Thermographie infrarouge ---- */}
          <article id="thermographie-infrarouge" className="svc-card reveal" aria-labelledby="thermo-title">
            <div className="svc-card__text">
              <div className="svc-badge">Diagnostic IR</div>
              <h3 className="svc-card__title" id="thermo-title">Thermographie infrarouge</h3>
              <p className="svc-card__desc">
                Cartographie thermique en électricité, bâtiment et process : points chauds, défauts d’isolation et pertes
                énergétiques identifiés sans interrompre la production.
              </p>
              <Link to="/services/thermographie-infrarouge" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/thermographie-infrarouge.jpg" alt="Thermographie de façade et d’armoire" loading="lazy" />
            </div>
          </article>

          {/* ---- Contrôle non destructif ---- */}
          <article id="controle-non-destructif" className="svc-card svc-card--alt reveal" aria-labelledby="cnd2-title">
            <div className="svc-card__text">
              <div className="svc-badge">CND / END</div>
              <h3 className="svc-card__title" id="cnd2-title">Contrôles non destructifs</h3>
              <p className="svc-card__desc">
                PT, MT, UT, RT, ET : inspection de surface et interne des matériaux et soudures, livrables exploitables
                et recommandations de maintenance.
              </p>
              <Link to="/services/controles-non-destructifs" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/Controle-nondestructif.jpg" alt="Essais non destructifs sur pièces soudées" loading="lazy" />
            </div>
          </article>

          {/* ---- Assistance Technique ---- */}
          <article id="assistance-technique" className="svc-card reveal" aria-labelledby="assist-title">
            <div className="svc-card__text">
              <div className="svc-badge">Ingénierie</div>
              <h3 className="svc-card__title" id="assist-title">Assistance Technique</h3>
              <p className="svc-card__desc">
                Études, suivi d’exécution, OPC, management qualité, assistance à l’exploitation/maintenance : un pilotage rigoureux
                pour des décisions fondées sur la mesure.
              </p>
              <Link to="/services/assistance-technique" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/assistance-technique.jpeg" alt="Ingénierie et conseils techniques" loading="lazy" />
            </div>
          </article>

          {/* ---- Contrôle de construction ---- */}
          <article id="controle-de-construction" className="svc-card svc-card--alt reveal" aria-labelledby="const-title">
            <div className="svc-card__text">
              <div className="svc-badge">Construction</div>
              <h3 className="svc-card__title" id="const-title">Contrôle de construction</h3>
              <p className="svc-card__desc">
                Analyse des études, inspections de chantier et avis techniques (RGC, NM/ISO, Eurocodes) pour des ouvrages sûrs,
                durables et conformes.
              </p>
              <Link to="/services/Controle_de_construction" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/controle-construction.jpg" alt="Contrôle technique sur chantier" loading="lazy" />
            </div>
          </article>

          {/* ---- Expertise maritime ---- */}
          <article id="maritime" className="svc-card reveal" aria-labelledby="sea-title">
            <div className="svc-card__text">
              <div className="svc-badge">Maritime</div>
              <h3 className="svc-card__title" id="sea-title">Expertise maritime</h3>
              <p className="svc-card__desc">
                Inspections, conformité ISM/SOLAS et levage portuaire ; interventions côtières et offshore avec rapports étayés
                et plan d’action.
              </p>
              <Link to="/services/expertise-maritime" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/expertise-maritime.jpg" alt="Expertise d’un navire au quai" loading="lazy" />
            </div>
          </article>

          {/* ---- Formation ---- */}
          <article id="formation" className="svc-card svc-card--alt reveal" aria-labelledby="form-title">
            <div className="svc-card__text">
              <div className="svc-badge">Formation</div>
              <h3 className="svc-card__title" id="form-title">Formation — VERATRAC ACADEMY</h3>
              <p className="svc-card__desc">
                Modules opérationnels (levage/PEMP, échafaudages, EPI, électricité, incendie) pour renforcer la compétence et
                la culture sécurité de vos équipes.
              </p>
              <Link to="/services/service-formation-academique" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/formation-academy.jpg" alt="Session de formation sécurité" loading="lazy" />
            </div>
          </article>

          {/* ---- Appareils à pression ---- */}
          <article id="appareils-a-pression" className="svc-card reveal" aria-labelledby="press-title">
            <div className="svc-card__text">
              <div className="svc-badge">Pression</div>
              <h3 className="svc-card__title" id="press-title">Appareils à pression</h3>
              <p className="svc-card__desc">
                Épreuves, inspections et visites réglementaires : prévention du risque d’explosion, protection des personnes
                et continuité d’activité (dahirs, arrêtés, Code du travail).
              </p>
              <Link to="/services/appareils-pression" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/pression.jpg" alt="Épreuve hydraulique d’un réservoir sous pression" loading="lazy" />
            </div>
          </article>

          {/* ---- Appareils de levage ---- */}
          <article id="appareils-de-levage" className="svc-card svc-card--alt reveal" aria-labelledby="levage2-title">
            <div className="svc-card__text">
              <div className="svc-badge">Levage</div>
              <h3 className="svc-card__title" id="levage2-title">Appareils de levage</h3>
              <p className="svc-card__desc">
                Contrôles de sécurité pour prévenir les chutes de charge (rupture de câble/chaîne, frein, fausses manœuvres)
                et fiabiliser l’exploitation.
              </p>
              <Link to="/services/levage" className="svc-link">Voir ce service</Link>
            </div>
            <div className="svc-card__media">
              <img src="/images/services/levage.jpeg" alt="Inspection de pont roulant" loading="lazy" />
            </div>
          </article>
        </div>
      </section>

      {/* ========= EXPÉRIENCE • EXPERTISE • ATOUTS ========= */}
      <section className="ami-section reveal ami-strengths" id="atouts" aria-labelledby="strengths-title">
        <div className="ami-col">
          <header className="ami-head">
            <span className="ami-badge" aria-hidden="true">VERATRAC SAFETY</span>
            <h2 className="ami-h2" id="strengths-title">
              <span className="ami-title">Expérience • Expertise • Nos atouts</span>
              <span className="ami-kicker">Ce qui fait la différence sur le terrain</span>
            </h2>
            <p className="ami-lead">
              Une culture de la prévention, des méthodes d’inspection éprouvées, et des livrables directement actionnables.
            </p>
          </header>

          <div className="strengths-grid">
            {strengths.map(({ title, Icon, points }) => (
              <article className="strength-card reveal" key={title}>
                <div className="strength-icon">
                  <Icon />
                </div>
                <h3 className="strength-title">{title}</h3>
                <ul className="strength-list">
                  {points.map((p, i) => (
                    <li key={i}><span className="dot" />{p}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <footer className="ami-cta">
            <a href="#contact" className="btn-primary">Faire une consultation</a>
              <a href="#services" className="btn-secondary">Explorer nos services</a>
          </footer>
        </div>
      </section>
    </main>
  );
}
